import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBuilding,
  faUsers,
  faComments,
  faChartLine,
  faFileInvoiceDollar,
  faExclamationTriangle,
  faMoneyBillTransfer,
  faTerminal,
  faShieldCheck,
  faBullhorn,
} from '@fortawesome/pro-light-svg-icons';


const colors = {
  text: '#37474f',
  textLight: '#78909c',
};

const menuItems = [
  { path: '/siteadmin/provider', label: 'Providers', icon: faBuilding, color: '#5c6bc0' },
  { path: '/siteadmin/user', label: 'Users', icon: faUsers, color: '#7e57c2' },
  { path: '/siteadmin/reviewmoderation', label: 'Review Moderation', icon: faComments, color: '#26a69a' },
  { path: '/siteadmin/reports', label: 'Reports', icon: faChartLine, color: '#42a5f5' },
  { path: '/siteadmin/billing', label: 'Finance Reports', icon: faFileInvoiceDollar, color: '#66bb6a' },
  { path: '/siteadmin/billing/overdue', label: 'Overdue Payments', icon: faExclamationTriangle, color: '#ffa726' },
  { path: '/siteadmin/billing/operations', label: 'Billing Operations', icon: faMoneyBillTransfer, color: '#ef5350' },
  { path: '/siteadmin/logs', label: 'Logs', icon: faTerminal, color: '#78909c' },
  { path: '/siteadmin/whitelist', label: 'Whitelisting', icon: faShieldCheck, color: '#26c6da' },
  { path: '/siteadmin/announcements', label: 'Announcements', icon: faBullhorn, color: '#ec407a' },
];

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 0;
`;

const NavItem = styled(Link)`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  text-decoration: none;
  color: ${({ $isActive }) => $isActive ? colors.text : colors.textLight};
  background: ${({ $isActive, $color }) => $isActive ? `${$color}12` : 'transparent'};
  font-size: 13px;
  font-weight: ${({ $isActive }) => $isActive ? '600' : '500'};
  transition: all 0.15s ease;
  position: relative;

  ${({ $isActive, $color }) => $isActive && `
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 3px;
      height: 24px;
      background: ${$color};
      border-radius: 0 3px 3px 0;
    }
  `}

  &:hover {
    background: ${({ $color }) => `${$color}10`};
    color: ${colors.text};
  }
`;

const IconWrapper = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $color, $isActive }) => $isActive ? $color : `${$color}15`};
  color: ${({ $color, $isActive }) => $isActive ? 'white' : $color};
  font-size: 14px;
  transition: all 0.15s ease;
`;

const Menu = () => {
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/siteadmin/billing') {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Nav>
      {menuItems.map((item) => {
        const active = isActive(item.path);
        return (
          <NavItem
            key={item.path}
            to={item.path}
            $isActive={active}
            $color={item.color}
          >
            <IconWrapper $color={item.color} $isActive={active}>
              <FontAwesomeIcon icon={item.icon} />
            </IconWrapper>
            {item.label}
          </NavItem>
        );
      })}
    </Nav>
  );
};

export default Menu;
